<script lang="ts">
  import { getContext } from "svelte"
  import { appStore } from "$app/store.svelte"

  let props = $props()
  let podcast_episode = props.podcast_episode || null

  const podcast_img = new URL(
    `/images/university/podcast-sm.jpg`,
    import.meta.url
  ).href
</script>

<a
  href="/plans/{appStore.plan.id}/podcast/{podcast_episode.id}"
  class="swiper-slide relative shadow-lg bg-gray-800 h-64 overflow-hidden"
>
  <img
    src={podcast_img}
    class="absolute inset-0 w-full object-fill opacity-80"
    alt="Surfacing Leaders Podcast"
  />
  <div class="absolute top-20 right-2 bg-gray-800 opacity-100 rounded-full">
    <span class="bg-blue-800 text-white rounded-lg py-1 px-2 font-bold text-lg"
      >EPISODE {podcast_episode.episode}</span
    >
  </div>
  <div class="absolute bottom-0 left-0 right-0">
    <div
      class="relative py-2 px-4 w-full justify-center bg-gray-800 opacity-90"
    >
      <p
        class="text-center text-lg lg:text-base font-medium text-white overflow-hidden"
      >
        {podcast_episode.title}
      </p>
    </div>
  </div>
</a>

<style>
  .swiper-slide {
    height: 16rem;
    -webkit-transition: 250ms all;
    transition: 250ms all;
  }

  .swiper-slide:hover {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
    z-index: 1;
  }

  .swiper-slide:first-child:hover {
    margin: 0 40px;
  }

  .swiper-slide:last-child:hover {
    margin: 0 -40px;
  }
</style>
